import React, { Component } from 'react';

import { Storage } from 'aws-amplify';
import { S3Album } from 'aws-amplify-react';

import {
    Button,
    Confirm,
    Icon,
    Header,
    Label,
    Menu,
    Message,
    Segment } from "semantic-ui-react";

const S3_FOLDER = 'displayed-in-app';

export default class Gallery extends Component {

    constructor(props) {
      super(props);

      this.state = {
          selectedImages: [],
          ts: new Date().getTime(),
          showDeleteSelectedConfirm: false,
          showHelpMessage: false,
      };
    }

    // Functions to control the display of dialogs and messages
    showDeleteSelectedConfirm = () => this.setState({ showDeleteSelectedConfirm: true })
    hideDeleteSelectedConfirm = () => this.setState({ showDeleteSelectedConfirm: false })
    showHelpMessage = () => this.setState({ showHelpMessage: true })
    hideHelpMessage = () => this.setState({ showHelpMessage: false })

    // Keep track of the images that are selected in the Album
    selectImage = (item) => {

        if (item === undefined || item === null) {
            return;
        }

        this.setState(prevState => {
            console.debug("The selected item is", item)
            if (item.selected) {
                prevState.selectedImages.push(item.key);
            } else {
                let index = prevState.selectedImages.indexOf(item.key);
                if (index > -1) {
                    prevState.selectedImages.splice(index, 1);
                }
            }
            return prevState;
        });
    }

    // Deleted all the images that were selected in the Album
    deleteSelected = () => {

        this.setState({ showDeleteSelectedConfirm: false });

        Promise.all(this.state.selectedImages.map(key => {
            return Storage.remove(key)
        })).then(() => {
            this.setState({
                selectedImages: [],
                ts: new Date().getTime()
            });
        }).catch(err => console.log(err));
    }

    // Open the File dialog to select an image to update.
    chooseImage = () => {
        this.refs.fileInput.click();
    }

    // Upload an image to the public/displayed-in-app directory after
    uploadImage = (e) => {
        const file = e.target.files[0];

        // If no file was chosen
        if (file === undefined) {
            return;
        }

        Storage.put(S3_FOLDER + '/' + file.name, file, {
          contentType: 'image/jpeg'
        }).then (result => {

            // Cause the Album to be refreshed
            this.setState({ ts: new Date().getTime() });
        }).catch(err => console.log(err));
    }


    render() {
        const DismissableMessage = (props) => {
            if (props.hidden) {
                return <Label as='a' content='Help' icon='help circle' onClick={this.showHelpMessage} />
            }

          return <Message info onDismiss={this.hideHelpMessage}
              header='Add and remove project gallery images.'
              list={[
                  'Uploaded images must be in 3:2 ratio landscape format to be displayed correctly.',
                  'To add an image click Upload Image then choose a JPEG image file.',
                  'To stop images being displayed, select all the images you want to remove, click Delete Selected, and confirm or cancel the deletion when the confirmation dialog displays.'
              ]} />
        }

        return (
            <Segment>
                <DismissableMessage hidden={!this.state.showHelpMessage} />
                <Header as='h4'>
                    <Icon name='block layout' size='small'/>
                    <Header.Content>
                        Project Gallery Images
                    </Header.Content>
                    <Header.Subheader>
                        Images in a 3:2 landscape ratio
                    </Header.Subheader>
                </Header>
                <Menu stackable>
                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Button color='blue' onClick={this.chooseImage}>
                                <Icon name='upload' />Upload Image
                            </Button>
                        </Menu.Item>
                        <Menu.Item>
                            <Button color='red' onClick={this.showDeleteSelectedConfirm}>
                                <Icon name='remove' />Delete Selected
                            </Button>

                            <Confirm
                                content='Are you sure you want to delete the selected images?'
                                open={this.state.showDeleteSelectedConfirm}
                                cancelButton='No'
                                confirmButton='Yes'
                                onCancel={this.hideDeleteSelectedConfirm}
                                onConfirm={this.deleteSelected}
                            />

                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
                <input ref='fileInput' type='file' accept='image/jpeg' hidden onChange={this.uploadImage}/>
                 <S3Album path={S3_FOLDER}
                    select
                    theme={{
                        photoImg: { width: '300px', height: '200px', padding: '4px' },
                        overlaySelected: { border: '2px solid red', marginLeft: '2px', marginRight: '2px' },
                        overlay: { margin: '4px' },
                        album: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' },
                        pickerPicker: { backgroundColor: '#2185d0', width: '50px' },
                        photoPickerButton: { backgroundColor: '#2185d0', color: 'white'}, button: { width: '50px'} }}
                    onSelect={this.selectImage}
                    ts={this.state.ts} />

             </Segment>

        );
    }
}
